module.exports = __webpack_public_path__ + "img/syukyaku-top-Z01.9009743c.png";